import { Rect, Size2, Vector2, fitRectAroundRectInRectBitch } from "peet-math";
import { Control } from "./control";
const interact = require('interactjs'); // Gesture intraction librairie
import $ from "jquery"
import { GestureVenuePlan } from "./gesture-venue-plan";
import { ViewPort } from "./viewport";

export type ContextMenuSettings = {
  items: ContextMenuItem[];
};

export type ContextMenuItem = {
  text: string;
  action: (pos: Vector2, plan: GestureVenuePlan) => void;
};

export class ContextMenuControl extends Control {
  public planEngine: GestureVenuePlan;
  public containerTag: JQuery<HTMLElement>;
  public settings: ContextMenuSettings;
  public panel: JQuery<HTMLElement>;
  public pointer: JQuery<HTMLElement>;;
  public shown: boolean;
  public position: Vector2;
  public fixedPosition: boolean;
  public panelSize: Size2;
  public basePinRect: Rect;

  constructor(planEngine, containerTag: JQuery<HTMLElement>, settings: ContextMenuSettings) {
    super();
    this.showAt = this.showAt.bind(this);
    this.render = this.render.bind(this);
    this.planEngine = planEngine;
    this.containerTag = containerTag;
    this.settings = settings;
    
    this.visible = false;
    this.panel = $("<ul class='context-menu' style='position:absolute;display:inline-block;top:0px;left:0px;'></ul>");
    this.pointer = $("<div class='pinpoint' style='position:absolute;display:block;top:0px;left:0px;'></div>");
    this.shown = false; // For performance purposes
    this.position = new Vector2(0, 0);
    this.fixedPosition = false; // This is for performance purposes to prevent change in position after the control is shown.

    //menu.element.hide()
    const getClickHandler = item => {
      return e => {
        e.preventDefault();
        e.stopPropagation();
        if (item.action != null) {
          item.action(this.position, this.planEngine);
        }
        return this.visible = false;
      };
    };

    for (let i in this.settings.items) {
      const item = this.settings.items[i];
      const mItem = $(`<li>${item.text}</li>`);
      interact(mItem[0]).on('down', getClickHandler(item));
      this.panel.append(mItem);
    }

    this.panel.hide();
    this.pointer.hide();
    this.containerTag.append(this.pointer);
    this.containerTag.append(this.panel);

    // This is a rect that represent the size of the pin based on it's css
    // We translate it to the right position we need to calculate things with it
    this.basePinRect = new Rect(parseInt(this.pointer.css("margin-left").replace("px", "")), parseInt(this.pointer.css("margin-top").replace("px", "")), this.pointer.width(), this.pointer.height()).
      pad(-10);
  }
    

  showAt(position) {
    this.position = position.clone();
    this.panelSize = new Size2(this.panel.width(), this.panel.height()); // Transfered because jquery is slow as hell and it cannot go in the render!
    return this.visible = true;
  }

  render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
    if (this.visible) {
      if (!this.shown || !this.fixedPosition) { // If first time or not fixed position
        // Ge tthe point position
        const posOnView = viewport.pointPToV(this.position);

        // Set the map pin at it's place
        // Important info: It's in the shown event just for performance purposes, if you really need it to be updated each time, test it outside and do what you need!
        this.pointer[0].style.left = posOnView.x.toString() + "px";
        this.pointer[0].style.top = posOnView.y.toString() + "px";
          
        const pinRect = this.basePinRect.translate(posOnView);
        //menuSize = new Size2 @panel.width(), @panel.height()
        const viewRect = new Rect(0, 0, viewport.sizeOnScreen.width, viewport.sizeOnScreen.height);

        
        const menuRect = fitRectAroundRectInRectBitch(pinRect, viewRect, this.panelSize, ["left", "top", "bottom", "right"]);

        this.panel[0].style.left = menuRect.x.toString() + "px";
        this.panel[0].style.top = menuRect.y.toString() + "px";
      }
      if (!this.shown) {
        this.panel.show();
        this.pointer.show();
        return this.shown = true;
      }
    } else {
      if (this.shown) {
        this.panel.hide();
        this.pointer.hide();
        return this.shown = false;
      }
    }
  }
}